const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    outline: '1px dashed #CBD0D7',
    padding: '8px 6px',
    borderRadius: '8px',
    margin: '8px 1px 8px 1px',
    '&:hover': {
      cursor: 'pointer',
      outline: '1px solid #5DADFF',
      backgroundColor: 'E3F3FF',
    },
  },
  containerWithoutSections: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    marginTop: '2px',
    outline: '1px dashed #5DADFF',
    backgroundColor: 'E3F3FF',
    padding: '16px 16px',
    borderRadius: '8px',
    height: '48px',
    margin: '0px 1px',
    '&:hover': {
      cursor: 'pointer',
      outline: '1px solid #5DADFF',
    },
  },
})

export default styles
